/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedStorytellingRelatedContent_storyTellingTab = {
    readonly relatedCreators: ReadonlyArray<{
        readonly creatorName: string;
        readonly creatorBrowseUrl: {
            readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
        };
    } | null> | null;
    readonly supplementaryEditorial: {
        readonly totalResults: number | null;
        readonly articles: ReadonlyArray<{
            readonly title: string;
            readonly imageUrl: {
                readonly thumb: string;
                readonly medium: string;
                readonly full: string;
            };
            readonly link: string;
            readonly source: string;
        }> | null;
    } | null;
    readonly " $refType": "PdpSharedStorytellingRelatedContent_storyTellingTab";
};
export type PdpSharedStorytellingRelatedContent_storyTellingTab$data = PdpSharedStorytellingRelatedContent_storyTellingTab;
export type PdpSharedStorytellingRelatedContent_storyTellingTab$key = {
    readonly " $data"?: PdpSharedStorytellingRelatedContent_storyTellingTab$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedStorytellingRelatedContent_storyTellingTab">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedStorytellingRelatedContent_storyTellingTab",
  "type": "StoryTellingTab",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "relatedCreators",
      "storageKey": null,
      "args": null,
      "concreteType": "StoryTellingModuleCreator",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "creatorName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "creatorBrowseUrl",
          "storageKey": null,
          "args": null,
          "concreteType": "LinkData",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SeoLink_linkData",
              "args": null
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "supplementaryEditorial",
      "storageKey": null,
      "args": null,
      "concreteType": "WordpressArticlesType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "totalResults",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "articles",
          "storageKey": null,
          "args": null,
          "concreteType": "WordpressArticleType",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "title",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "imageUrl",
              "storageKey": null,
              "args": null,
              "concreteType": "WordpressArticleImageType",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "thumb",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "medium",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "full",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "link",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "source",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '0dde0244650c9dae7762e15b2123d118';
export default node;
